<div class="main-content">
  <app-header [title]="'HEADER.TITLE_REQUEST' | translate" [subtitle]="'HEADER.SUBTITLE_REQUEST' | translate" />

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'PARTNER', 'ADMIN']">
        <div class="banner d-flex flex-column flex-md-row" [ngClass]="isLight ? 'light' : 'dark'">
          <div class="d-flex align-items-center">
            <div class="icon-circle me-3">
              <app-icam-icon [iconName]="'info-white-big'" iconColor="green" [iconHeight]="'25px'" [isDefault]="true" />
            </div>
            <div class="text-container text-center">
              <h2 class="my-0 py-0">
                <span class="text-container-bold">{{ 'BANNER.NEED_INFO' | translate }} </span>
                <span class="fw-normal">{{ 'BANNER.ASK_INFO' | translate }}</span>
              </h2>
            </div>
          </div>
          <div class="button-container mt-3 mt-md-0">
            <button class="ticket-button" [routerLink]="['/request', 'new']">
              {{ 'BANNER.INFORMATION' | translate }}
            </button>
          </div>
        </div>
      </app-icam-container>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'info-circle'">
        <app-table
          [allValues$]="requests$"
          type="requests"
          (selectedFilter)="onSelectedFilter($event)"
          [hasChart]="false"
          [filters$]="requestFilter$"
          (selectedPage)="onClickPage($event)"
          [prevPage]="prevPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          [totalPages]="totalPages"
          [useInlineKeywordFilter]="true"
        />
      </app-icam-container>
    </div>
  </div>
</div>
